/**
 * Parking-spot helpers for the property form: parking type only applies when
 * the listing has at least one parking spot.
 */

/**
 * Whether the parking-type control should be shown for the given spot count.
 *
 * @param parkingSpots - Number of parking spots selected on the form.
 * @returns True when the user should pick a parking type.
 */
export function shouldShowParkingType(
  parkingSpots: number | null | undefined,
): boolean {
  return (parkingSpots ?? 0) > 0;
}

/**
 * Resolves the parking type to persist: clears it when there are no spots.
 *
 * @param parkingSpots - Number of parking spots on the form.
 * @param parkingType - Selected parking type, if any.
 * @returns The parking type to store, or undefined when spots are zero.
 */
export function parkingTypeWhenSpotsExist(
  parkingSpots: number | null | undefined,
  parkingType: string | null | undefined,
): string | undefined {
  if (!shouldShowParkingType(parkingSpots)) return undefined;
  return parkingType || undefined;
}
